import { NavLink } from "react-router-dom";
import ThemeSwitcher from "./ThemeSwticher/ThemeSwitcher";
import translator from "../../Components/Extra/Translation/Translate";
import useAuthentication from "../../Services/Authentication/useAuthentication";
import Dropdown from "../../Components/Extra/Dropdown/Dropdown";
import LanguageSwitcher from "./Language/Language";
import Notification from "../../Components/Extra/Notification/Notification";
import { LogoClisha } from "../../Components/logo/logo";

const Head = () => {
    const { isAdmin } = useAuthentication();
    const { translate } = translator();
    return (
        <div className="top-bar mdg-nav-bar mdg-theme-nav z-50">
            <nav
                aria-label="breadcrumb"
                className="-intro-x mr-auto hidden sm:flex"
            >
                <div className="p-4 sm:w-64">
                    <NavLink
                        to="/"
                        className="active mdg-logo mx-auto !mt-[-10px] flex h-10 w-full justify-center text-orange-500 hover:text-yellow-500"
                        aria-current="page"
                    >
                        <LogoClisha className="h-[50px] w-auto" />
                    </NavLink>
                </div>
            </nav>
            <div className="flex items-center justify-end">
                {isAdmin && (
                    <div className="intro-x relative mr-3 sm:mr-6">
                        <NavLink
                            to="/admin/dashboard"
                            className="btn btn-default-soft w-30 p-2 text-white border-gray-500"
                        >
                            {translate("Head", "Administrator")}
                        </NavLink>
                    </div>
                )}
                <div className="intro-x mr-3 sm:mr-6 language">
                    <LanguageSwitcher />
                </div>
                <div className="intro-x dropdown mr-5 flex h-7 w-5 items-center">
                    <ThemeSwitcher />
                </div>
                <div className="intro-x w-8 h-8 mr-2 notif">
                    <Notification />
                </div>
                <div className="intro-x w-8 h-8 profil">
                    <Dropdown />
                </div>
            </div>
        </div>
    );
};

export default Head;
